import { render } from "./SubmenuTopLinks.vue?vue&type=template&id=450710ba"
import script from "./SubmenuTopLinks.vue?vue&type=script&lang=js"
export * from "./SubmenuTopLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__